import api from "@/services/api/whales";

const state = {
  isLoading: false,
  items: [],
  roles: [],
  searchQuery: "",
  searchOptions: {
    page: 1,
    itemsPerPage: 10,
    sortBy: ["whaleId"],
    sortDesc: [false],
    multiSort: false,
  },
  total: 0,
  whaleIds: [],
  unregisteredWhales: [],
  archived: false,
};

const getters = {
  loading: (state) => state.isLoading,
  items: (state) => state.items,
  searchQuery: (state) => state.searchQuery,
  searchOptions: (state) => state.searchOptions,
  total: (state) => state.total,
  whaleIds: (state) => state.whaleIds,
  unregisteredWhales: (state) => state.unregisteredWhales,
  archived: (state) => state.archived,
};

const actions = {
  async search({ commit, state }, { query, species, page, itemsPerPage, sortBy, sortDesc }) {
    commit("loading", { isLoading: true });
    const result = await api.search({
      query,
      species,
      page,
      itemsPerPage,
      sortBy,
      sortDesc,
      archived: state.archived,
    });
    commit("loaded", {
      items: result.data,
      searchQuery: query,
      searchOptions: { species, page, itemsPerPage, sortBy, sortDesc },
      total: result.total,
    });
    commit("loading", { isLoading: false });
  },
  async reload({ dispatch, state }) {
    dispatch("search", {
      query: state.searchQuery,
      ...state.searchOptions,
    });
  },
  async deleteWhale({ dispatch }, whaleId) {
    await api.delete(whaleId);
    dispatch("reload");
  },
  setArchived({ commit }, archived) {
    commit("setArchived", archived);
  },
  async setWhaleArchived(_context, { id, isArchived }) {
    if (isArchived) {
      await api.archive(id);
    } else {
      await api.restore(id);
    }
  },
  async loadWhaleIds({ commit }) {
    const result = await api.whaleIds();
    commit("setWhaleIds", result.data);
  },
  async loadUnregisteredWhales({ commit }) {
    const result = await api.unregisteredWhaleIds();
    commit("setUnregisteredWhales", result.data);
  },
};

const mutations = {
  loading(state, { isLoading }) {
    state.isLoading = isLoading;
  },
  loaded(state, { items, searchQuery, searchOptions, total }) {
    state.searchQuery = searchQuery;
    state.searchOptions = { ...searchOptions };
    state.total = total;
    state.items = items;
  },
  setWhaleIds(state, whaleIds) {
    state.whaleIds = whaleIds;
  },
  setUnregisteredWhales(state, unregisteredWhales) {
    state.unregisteredWhales = unregisteredWhales;
  },
  setArchived(state, archived) {
    state.archived = archived;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
